import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';
import _ from 'lodash';

export class IlluminanceMeasurementServerPlugin extends SmartenitPlugin {
  private measuremenValue: number = 0;
  // Methods
  public getStatusPayload(): any {
    return ['MeasuredValue'];
  }

  public getReportableAttrs() {
    return ['MinMeasuredValue'];
  }

  public setValue(value: number, attribute?: string | undefined): void {
  }

  public getValue(attribute?: string | undefined): number {
    return this.measuremenValue;
  }

  public formatValue(value: string): string {
    return value;
  }

  public getUnit(attribute?: string | undefined): string {
    return 'Lux';
  }

  public getConditionOptions(): any {
    return null;
  }

  public getConditionAttribute(): string {
    // return this by default but client can choose the attribute from JSON
    return 'IlluminanceValue';
  }

  public processMessage(message: IWebSocketDeviceMessage, timestamp?: number): any {
    const response = message && message.data && message.data.response;
    const attribute = message && message.attributeOrMethod;

    if (attribute === 'MeasuredValue') {
      this.measuremenValue = response.value;
      this._onUpdate.next({ measuredValue: this.measuremenValue });
    }
  }
}
